//export const url_local = 'http://localhost/Navicar/backends/public/api/'
//export const url_web = 'http://localhost/Navicar/backends/public/'

//export const url_local = 'http://www.codeworkvenezuela.com/jose/navicar/backend/public/api/';
//export const url_web = 'http://www.codeworkvenezuela.com/jose/navicar/backend/public/';

///ESTA URL ES LA DE PRODUCCION
export const url_local =
  "https://navitime.logicservicesllc.com/backend/public/api/";
export const url_web = "https://navitime.logicservicesllc.com/backend/public/";
